import { Button, Form, IFormRender, Theme } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ClassName } from "types/ClassName";
import { useToastDispatch } from 'contexts/ToastContext';
import { usePositionUpdate } from 'hooks';
import { isEqual } from 'lodash';
import { useRef } from 'react';
import IPosition from 'types/Position';
import { t } from 'utils/localize';
import PositionsViewActivityReportFormFields from '../components/PositionsViewActivityReportFormFields';

export interface IPositionDetailsActivityReportFormProps {
  position: IPosition;
  onSubmit: (formData: { viewAllActivityReport: boolean; viewMemberActivityReport: number }) => void;
  className?: ClassName;
}

export interface IPositionDetailsActivityReportFormData {
  viewAllActivityReport: string;
  viewMemberActivityReport: number;
}

function PositionDetailsActivityReportForm({ position, onSubmit, className }: IPositionDetailsActivityReportFormProps) {
  const initialFormData = useRef<IPositionDetailsActivityReportFormData>({
    viewAllActivityReport: position.viewAllActivityReport ? '1' : '0',
    viewMemberActivityReport: position.viewMemberActivityReport!,
  });
  const [, update] = usePositionUpdate();
  const toastDispatch = useToastDispatch();

  function renderFormFields(form: IFormRender<IPositionDetailsActivityReportFormData>) {
    return (
      <>
        <PositionsViewActivityReportFormFields form={form} />
        <Button type="primary" onClick={form.handleSubmit}>
          {t('Update')}
        </Button>
      </>
    );
  }
  async function onFormSubmit(data: IPositionDetailsActivityReportFormData) {
    const { viewAllActivityReport, viewMemberActivityReport } = data;
    const viewAllActivityReportBool = viewAllActivityReport === '1';
    if (!isEqual(data, initialFormData.current)) {
      try {
        await update({
          id: position.id,
          viewAllActivityReport: viewAllActivityReportBool,
          viewMemberActivityReport: !viewAllActivityReportBool ? viewMemberActivityReport : 15,
        });
      } catch (e) {
        toastDispatch({
          type: 'OPEN',
          payload: {
            theme: Theme.DANGER,
            label: t('There was a problem updating your position. Please try again later.'),
          },
        });
      }
    }

    onSubmit({ viewAllActivityReport: viewAllActivityReportBool, viewMemberActivityReport });
  }

  return (
    <Form
      className={classNames('position-details-activity-report-form', 'mt-4', className)}
      render={renderFormFields}
      onSubmit={onFormSubmit}
      data={initialFormData.current}
    />
  );
}

export default PositionDetailsActivityReportForm;
